<template>
  <v-app style="background:#01000A;">
    <Navbar />
    <v-main id="main-container">
      <router-view :key="$route.fullPath" />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
export default {
  components: {
    Navbar
  },
  data() {
    return {
      // drawer: true,
      // items: [
      //   { title: 'Catalogue', icon: 'mdi-view-dashboard', route: 'Welcome' }
      //   // {
      //   //   title: 'Cube',
      //   //   icon: 'mdi-image',
      //   //   route: 'Catalogue',
      //   //   scene: 'cube'
      //   // },
      //   // {
      //   //   title: 'Pyramid',
      //   //   icon: 'mdi-help-box',
      //   //   route: 'Catalogue',
      //   //   scene: 'pyramid'
      //   // }
      // ],
      // color: 'primary',
      // colors: ['primary', 'blue', 'success', 'red', 'teal', 'brown'],
      // right: false,
      // permanent: true,
      // miniVariant: true,
      // expandOnHover: true,
      // background: false
    }
  }
}
</script>

<style>
@import './app.css';
html {
  /* scroll-behavior: smooth; */
  -ms-overflow-style: none; /* Hide scrollbar IE and Edge */
  scrollbar-width: none; /* Hide scrollbar Firefox */
}
html::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}
</style>
